import { EventObject, fromCallback, fromPromise, setup } from 'xstate';

import { patientMatchWithProvider, PublicAppointment } from '@uplift/api';
import { AgeGroupEnum } from '@uplift/types';

import { environment } from '../../../../../environments/environment';
import {
  LoadActorReturnType, BetterhelpOnboardingMachineContext, BetterhelpOnboardingMachineEvent
} from '../types';

type BookingSecondInput = {
  appointment: PublicAppointment;
  providerId: string;
  userId: string;
};

export const betterhelpMachineSetup = setup({
  types: {
    context: {} as BetterhelpOnboardingMachineContext,
    events: {} as BetterhelpOnboardingMachineEvent,
  },
  actors: {
    handleHistoryPop: fromCallback(() => {
      return;
    }),
    load: fromPromise(async (): Promise<LoadActorReturnType> => {
      return {};
    }),
    syncRouteActor: fromCallback<EventObject, { route: string }>(() => {
      return;
    }),
    bookingSecond: fromPromise<void, BookingSecondInput>(async ({ input }) => {
      const response = await patientMatchWithProvider({
        providerId: input.providerId,
        fromDatetime: input.appointment.fromDatetime,
      });

      if (!response?.data?.created || response?.data?.error) {
        const errorMessage = response?.data?.error || 'Unknown error';

        console.error('Error creating appointment', errorMessage);
        throw new Error(errorMessage);
      }
    })
  },
  actions: {
    redirectToLogin: () => window.location.href = environment.authUrl
  },
  guards: {
    isTooYoung: ({ context, event }) => {
      let age = context.age;

      if (event.type === 'Age.Next') {
        age = event.data.age;
      }

      return age.ageGroup === AgeGroupEnum.children;
    },
    isInsuranceMedicaid: () => {
      return false;
    },
  }
});
